/* eslint-disable perfectionist/sort-imports */
import { scan } from "react-scan";
import * as Sentry from "@sentry/react";
import posthog from "posthog-js";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router";

import { shouldDropSentryEvent } from "@/lib/sentry-event-filters";
import { router } from "@/router";

import "@fontsource-variable/dm-sans/index.css";
import "@/index.css";

import "@/lib/i18next";

// @ts-expect-error - This is a global variable injected by the server
window.reactscan = scan;

Sentry.init({
  beforeSend: event => shouldDropSentryEvent(event) ? null : event,
  dsn: "https://09ef782cd05e4bd68f2342ec4f583434@o4508870745391104.ingest.de.sentry.io/4508870748602448",
  integrations: [posthog.sentryIntegration({
    organization: "teamz-p4",
    projectId: 4508870748602448,
    severityAllowList: ["error", "fatal"], // optional: here is set to handle captureMessage (info) and captureException (error)
  },
  )],
  environment: import.meta.env.MODE,
  enabled: import.meta.env.MODE !== "development",
  allowUrls: [
    /https:\/\/(.*\.)?teamz-tennis\.com/u,
    /https:\/\/(.*)\.teamz\.pages\.dev/u,
  ],
});

const root = document.getElementById("root");
if (!root) {
  throw new Error("No root element found");
}

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
